module.exports = __webpack_public_path__ + "static/media/baleine5.c4843027.jpg";